import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/internal/Observable';
import set = Reflect.set;

@Injectable({
  providedIn: 'root'
})
export class DescriptorService {

  constructor(private httpClient: HttpClient) {
   
  }

  getProperties(nlpId: string): Observable<any> {
    return this.httpClient.get(`apiUrl/omnis/search/${nlpId}`);
  }

  getWikiDataData(bnId: string, viafId: string , descriptor: string, language: string): Observable<any> {
    const params = new HttpParams()
      .append('bnId', bnId)
      .append('viafId', viafId)
      .append('descriptor', descriptor)
      .append('language', language);
    return this.httpClient.get("wikiDataUrl/getAdditionalInformation", {params: params});
  }

}
